import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {LoginLogoutService} from '../services/auth/login-logout.service';
import {PrivilegeService} from '../services/privilege.service';
import {Observable, of, tap, firstValueFrom, timeout, filter} from 'rxjs';
import {AuthService} from '@auth0/auth0-angular';
import {AuthOktaService} from '../services/auth/auth-okta.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, public privilegeService: PrivilegeService,
              private authService: LoginLogoutService, private auth: AuthService,
              private authOktaService: AuthOktaService) {
  }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    // Wait for organization ID to be fetched before deciding
    await this.authOktaService.getOrganizationId();

    // Now check if MFA is enabled based on the fetched organization ID
    const isMfaEnabled = this.privilegeService.isAuth0Enabled();

    if (isMfaEnabled) {
      try {
        // Wait for Auth0 to finish loading
        await firstValueFrom(this.auth.isLoading$.pipe(filter(isLoading => !isLoading)));

        const isAuthenticated = await firstValueFrom(
          this.auth.isAuthenticated$.pipe(
            timeout(5000) // 5 second timeout
          )
        );

        if (!isAuthenticated) {
          this.authOktaService.signIn();
          return false;
        }
        return isAuthenticated;
      } catch (error) {
        return true;
      }
    } else {
      const isLoggedIn = this.authService.isUserLoggedIn();
      if (isLoggedIn) {
        return true;
      }

      console.log('AuthGuard: Not logged in, redirecting to login');
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 150);
      return false;
    }
  }
}
